import type { ReorderedRouteType } from '../AssignmentApi';
import type {
    RoutePointDeltaType,
    RoutePointExtendedType,
} from '../../../utilities/RoutePointsApi';
import type { Assignment } from '../Assignment';

export class RoutePointCalc {
    public static getEta(
        modifiedRouteData: ReorderedRouteType | null,
        routePoint: RoutePointExtendedType | null,
        assignment: Assignment
    ): number | null {
        // if (modifiedRouteData == null) {
        //     return null;
        // }
        if (routePoint == null) {
            return null;
        }
        let eta: number | null = null;
        let delta: RoutePointDeltaType | null = this.getDelta(modifiedRouteData, routePoint);
        let start_time_m =
            modifiedRouteData?.start_time_m || assignment.getRouteInfo()?.route?.start_time_m;
        if (typeof start_time_m == 'number') {
            if (delta && typeof delta?.g?.t == 'number') {
                eta = (start_time_m + delta.g.t) % (24 * 60);
            }
        }
        return eta;
    }

    public static getDelta(
        modifiedRouteData: ReorderedRouteType | null,
        routePoint: RoutePointExtendedType
    ): RoutePointDeltaType | null {
        try {
            return modifiedRouteData?.deltas[routePoint.point_order] || routePoint.delta;
        } catch (e) {
            console.error('Error in getDelta', e);
            return null;
        }
    }
}
